import { DrawCabinetInsideElement } from './DrawCabinetInsideElement';

export class DrawInsideTrashCan extends DrawCabinetInsideElement {
    Number!: number;
    Pattern!: number;
}
